import {gsap} from "gsap";

window.addEventListener('DOMContentLoaded', (event) => {
    const elements = document.querySelectorAll('.animate');
    
    elements.forEach(element => {
        gsap.to(element, {
            scrollTrigger: {
                trigger: element,
                start: "top bottom"
            },
            visibility: 'visible',
            opacity: 1
        })
    });
});